import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetDriversCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IGetDriversCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'vehicleOwners/{ownerId}/drivers';

  override setParameters(parameters: IGetDriversCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{ownerId}',
      parameters.ownerId
    );
  }
}
export interface IGetDriversCommandParameters extends ICommandParameters {
  ownerId: string;
}
